import { Route, Routes } from 'react-router';
import { AuthenticationRoutes } from './modules/authentication';
import { ConfigurationRoutes, PlayerRoutes } from './modules';
import { Toaster } from 'components/shadcn/sonner';
import {
  AuthProtectedRoute,
  DeviceProtectedRoute,
  PlayerProtectedRoute,
} from './shared';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from 'components/custom';

export const App = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Toaster richColors position="top-right" />
      <Routes>
        {/* Public auth routes */}
        <Route element={<AuthProtectedRoute />}>
          <Route path="/auth/*" element={<AuthenticationRoutes />} />
        </Route>

        {/* Device configuration routes */}
        <Route element={<DeviceProtectedRoute />}>
          <Route path="/device/*" element={<ConfigurationRoutes />} />
        </Route>

        {/* Main app routes */}
        <Route element={<PlayerProtectedRoute />}>
          <Route path="/*" element={<PlayerRoutes />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
};
